import { render, staticRenderFns } from "./SUBJECTDL.vue?vue&type=template&id=8cbff6c8&scoped=true&"
import script from "./SUBJECTDL.vue?vue&type=script&lang=js&"
export * from "./SUBJECTDL.vue?vue&type=script&lang=js&"
import style0 from "./SUBJECTDL.vue?vue&type=style&index=0&id=8cbff6c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbff6c8",
  null
  
)

export default component.exports